import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { MediaReducer } from './medias/mediaReducer';
import { ViewReducer } from './layout/layoutReducer';
import { NameTagsReducer } from './nametags/NameTagsReducer';
import { ProducerReducer } from './producers/producersReducer';
import { TemplateReducer } from './templates/templateReducer';
import { MeetingReducer } from './meeting/meetingReducer';

const store = configureStore({
  reducer: {
    producers: ProducerReducer,
    layout: ViewReducer,
    media: MediaReducer,
    templates: TemplateReducer,
    nametags: NameTagsReducer,
    meetingStore: MeetingReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
export default store

export type RootState = ReturnType<typeof store.getState>